import React, { Component } from 'react'
import { PageWrapper, FormikForm, SelectBox, Button, Header, DefaultText, FlexWrapper } from '../components'
import styled from 'styled-components'
import { Formik, Field } from 'formik'
import 'react-table/react-table.css'
import { get } from 'lodash'
import axios from 'axios'
import { API_URL, FRESHDESK_URL, FRESHDESK_AUTH, IS_DEV } from '../constants'

class UpdateUpcCode extends Component {
  state = {
    loader: false,
    selectedOption: [],
    selectedOptionNominate: [],
    showProductModal: false,
    productDetail: {},
    userId: null,
    userEmail: null,
    upcScanned: null
  }

  componentDidMount() {
    const userId = get(this.props, 'location.state.userId', false)
    const userEmail = get(this.props, 'location.state.userEmail', false)
    const upcScanned = get(this.props, 'location.state.upcScanned', false)
    this.setState({ userId, userEmail, upcScanned })
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption })
  }

  handleChangeNominate = selectedOptionNominate => {
    this.setState({ selectedOptionNominate: selectedOptionNominate })
  }

  async fetchAsyncProductsData(value) {
    if (value) {
      try {
        const { data } = await axios.post(`${API_URL}/producttablemergeds/getProductsBySearch`, {
          searchTerm: value,
          filters: [],
          offset: 0,
          limit: 50
        })
        this.setState({ products: data })
      } catch (error) {
        console.log('ERROR', error)
      }
    }
    return this.state.products
  }

  loadProducts = async inputValue => {
    try {
      let newData = []
      newData = await this.fetchAsyncProductsData(inputValue)
      return newData.map(item => ({
        value: item.productCode,
        label: `${item.productName + item.productQuantity}`,
        name: `${item.productName}`,
        productsData: item
      }))
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    const { selectedOption, isLoading, selectedOptionNominate, userId, userEmail, upcScanned } = this.state
    return (
      <React.Fragment>
        <Header
          icon="arrowBack"
          title={'Update Upc Code'}
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          color="#fff"
        />
        <PageWrapper viewPadding="0 20px" height={'calc(100% - 0px)'} modifyPadding="0 20px" style={{ paddingTop: 60 }}>
          <Formik
            enableReinitialize
            initialValues={{}}
            onSubmit={async (val, { resetForm }) => {
              this.setState({ isLoading: true })
              const {
                productDetail,
                selectedOption,
                selectedOptionNominate,
                userId,
                userEmail,
                upcScanned
              } = this.state
              if (get(selectedOption, 'value', false)) {
                await axios.post(`${API_URL}/producttablemergeds/update-product-detail`, {
                  productCode: get(productDetail, 'value'),
                  data: { upcCode: upcScanned }
                })
                await axios.patch(`${API_URL}/UpcTracks/${get(this.props, 'match.params.id', null)}`, {
                  isCorrect: true
                })
              }
              if (get(selectedOptionNominate, 'value', false)) {
                let freshDeskSubject = ''
                if (IS_DEV) {
                  freshDeskSubject = '[DEV] '
                }
                axios
                  .post(
                    `${FRESHDESK_URL}`,
                    {
                      description: `Type: Nominate Product, UPC Code: ${upcScanned}, Product Name: ${get(
                        productDetail,
                        'name'
                      )}, Product Code: ${get(productDetail, 'value')}, User Id: ${userId}, Email: ${userEmail}`,
                      subject: `${freshDeskSubject}UPC Scanning Admin Panel`,
                      email: userEmail,
                      priority: 1,
                      status: 2
                    },
                    {
                      auth: {
                        username: FRESHDESK_AUTH.username,
                        password: FRESHDESK_AUTH.password
                      }
                    }
                  )
                  .catch(error => console.log(error))
              }
              this.props.history.push('/view-upccode-native')
              resetForm()
              this.setState({
                isLoading: false,
                selectedOption: [],
                selectedOptionNominate: []
              })
            }}
            render={formikBag => (
              <FormikForm
                style={{
                  padding: '0 20px',
                  border: '2px solid'
                }}>
                <FlexWrapper>
                  <FlexWrapper direction="row">
                    <div
                      style={{
                        margin: '30px 10px 10px 10px',
                        display: 'flex',
                        width: '100%',
                        flexDirection: 'column'
                      }}>
                      <DefaultText padding="0 0 10px 0">
                        <span
                          style={{
                            width: '100%',
                            fontSize: '12px',
                            textTransform: 'uppercase',
                            display: 'block',
                            color: '#b1b1b1'
                          }}>
                          User Id
                        </span>
                        {userId}
                      </DefaultText>
                      <DefaultText padding="0 0 10px 0">
                        <span
                          style={{
                            width: '100%',
                            fontSize: '12px',
                            textTransform: 'uppercase',
                            display: 'block',
                            color: '#b1b1b1'
                          }}>
                          User Email
                        </span>
                        {userEmail}
                      </DefaultText>
                      <DefaultText padding="0 0 10px 0">
                        <span
                          style={{
                            width: '100%',
                            fontSize: '12px',
                            textTransform: 'uppercase',
                            display: 'block',
                            color: '#b1b1b1'
                          }}>
                          Upc Scanned
                        </span>
                        {upcScanned}
                      </DefaultText>
                    </div>
                  </FlexWrapper>
                  <Field
                    name="product"
                    render={({ field }) => (
                      <SelectBox
                        cacheOptions
                        isClearable={true}
                        defaultOptions={true}
                        loadOptions={this.loadProducts}
                        isSelected
                        placeholder="Search Product"
                        onChange={product => {
                          if (product) {
                            this.setState({ productDetail: product })
                          }
                        }}
                      />
                    )}
                  />
                </FlexWrapper>
                <Field
                  name="upcCode"
                  render={({ field }) => (
                    <SelectBox
                      name="upcCode"
                      label="Set Upc Code"
                      placeholder="Set Upc Code"
                      options={[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]}
                      value={selectedOption}
                      onChange={this.handleChange}
                      selectField
                    />
                  )}
                />
                <Field
                  name="nominate"
                  render={({ field }) => (
                    <SelectBox
                      name="nominate"
                      label="Nominate Product"
                      placeholder="Nominate Product"
                      options={[{ value: true, label: 'Yes' }, { value: false, label: 'No' }]}
                      value={selectedOptionNominate}
                      onChange={this.handleChangeNominate}
                      selectField
                    />
                  )}
                />

                <Button
                  style={{ lineHeight: 2.4, marginBottom: 20 }}
                  volume="filled"
                  type="submit"
                  label="Submit"
                  disabled={isLoading}
                  isLoading={isLoading}
                />
              </FormikForm>
            )}
          />
        </PageWrapper>
      </React.Fragment>
    )
  }
}
export default UpdateUpcCode



// WEBPACK FOOTER //
// ./src/pages/UpdateUpcCode.js